import React, { Component } from 'react';
import FetchCall, { partnerApi } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class Admission_other extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      main_access: '',
      dropdown: { documents: [] },
      access: [],
      documents: [],
      admission_link: '',
      admission_process: '',
      is_refund: '',
      application_fee: '0',
      other_fee: '0',
      average_fee: '0',
      class_fee: '0',
      class_fee_type: '0',
      recurring_fee: '0',
      active_status: 0,
      collapse: 0,
      page_data: [],
      btnDisabled: true
    }
    this.validator = new SimpleReactValidator();
    this.getDropData();
    this.getKeyInfo();
    this.toggle = this.toggle.bind(this);
  }
  componentDidMount() {
  }
  async getKeyInfo() {
    const { user_type, login_id, set_id } = this.state.user_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getKeyInfoNew'
    });
    await partnerApi(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({
          btnDisabled: false,
          active_status: response.result.active_status,
          page_data: response.result.master_data,
        })
      }
    })
  }

  handleChange = (e, index) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    let page_data = this.state.page_data;
    page_data[index][propName] = propValue;
    this.setState({ page_data });
  };
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }

  documentHandleSelect = (e, i) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    let page_data = this.state.page_data;

    page_data[i][propName] = value;
    this.setState({ page_data });
  };

  handleSelect = (e, i) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    let page_data = this.state.page_data;

    page_data[i][propName] = value;
    this.setState({ page_data });
  };
  render() {
    const { access, dropdown, page_data, collapse } = this.state;
    const { user_type } = this.state.user_data;
    console.log('dropdown.documents', dropdown.documents)
    this.validator.purgeFields();
    return (
      <React.Fragment>

<div class="category_block">

<div class="titleline">
  <h4>Admission and Fee Info</h4>
</div>
        

          {page_data.map((item, index) => {
            const lbl_annual = item.cid == 6 ? 'Monthly' : 'Annual';
            const lbl_entry = item.cid == 7 ? 'Charges/Event (Starts From)' : 'Entry Fees';
            let second_category = item.second_category ? item.second_category.split(',') : [];
            return (

                
              <div className='eachblockgap'>
                   
                   <form onSubmit={(e) => this.submitForm(e, index)}>
              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                <CardHeader onClick={() => this.toggle(index)} data-event={index} className='custom-card-heading'>
                  <b>{item.category_name}</b>
                  <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                  {collapse !== index ? (
                    <span className='pull-right'>
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </span>
                  ) : (
                    <span className='pull-right'>
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </span>
                  )}
                </CardHeader>
                <Collapse isOpen={collapse === index}>
                  <CardBody className='panel-body'>

                   <h3 className="page-header">{item.organisation_name} <span style={{fontSize:"10px"}}><b>{item.set_id==3?"Branch":""}</b></span></h3>
                   <p className='mar-btm'>{item.address}</p>

                    <div class="box-shadow-custom">
                      {item.is_active == 0 ?
                        (
                          <div className='row mar-btm'>
                            <div class="form-group col-md-12">
                              <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                            </div>
                          </div>
                        ) :
                        (
                          <div className='container'>
                            {(item.cid == 1 || item.cid == 2) && (
                              (
                                <div className='row'>
                                  <div class="form-group col-md-12">
                                    <label> Admission Link</label>
                                    <input name='admission_link' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.admission_link}  />
                                    {this.validator.message('Admission Link', item.admission_link, 'required', { className: 'text-danger error-msg' })}
                                  </div>

                                <div class="form-group col-4">
                                  <label> Average {lbl_annual} Fees (INR) <span class="astrick">*</span></label>
                                  <input name='average_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.average_fee} />
                                  {this.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required', { className: 'text - danger error - msg' })}
                                </div>
                                <div class="form-group col-4">
                                  <label> Recurring Fees (INR)</label>
                                  <input name='recurring_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.recurring_fee} />
                                  {this.validator.message('Recurring Fees', item.recurring_fee, 'required', { className: 'text-danger error-msg' })}
                                </div>

                                <div class="form-group col-4">
                                    <label> Application Fees (INR)</label>
                                    <input name='application_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.application_fee}   />
                                    {this.validator.message('Application Fees', item.application_fee, 'required', { className: 'text-danger error-msg' })}
                                  </div>

                                  <div class="form-group col-4">
                                    <label> Other Fees (INR)</label>
                                    <input name='other_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.other_fee}   />
                                    {this.validator.message('Other Fees', item.other_fee, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                  <div class="form-group col-4">
                                    <label>Is Refundable (Application Fees) <span class="astrick">*</span></label><br />
                                    <input
                                      type="radio"
                                      name="is_refund"
                                      checked={item.is_refund === '1'}
                                      value='1'
                                      onChange={(e) => this.handleChange(e, index)}
                                    /> Yes&nbsp;&nbsp;
                                    <input
                                      type="radio"
                                      name="is_refund"
                                      checked={item.is_refund === '2'}
                                      value='2'
                                      onChange={(e) => this.handleChange(e, index)}
                                    /> No &nbsp;&nbsp;&nbsp;

                                    {/* {this.validator.message('Is Refund', this.state.is_refund, 'numeric', { className: 'text-danger error-msg' })} */}
                                  </div>

                                  <div class="form-group col-4">
                                    <label> Required Documents</label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='documents'
                                      value={item.documents}
                                      title='Select Documents'
                                      onChange={(e) => this.documentHandleSelect(e, index)}>
                                      {dropdown.documents && dropdown.documents.map((val, i) => {
                                        return (
                                          <option value={val.id} key={i} >
                                            {val.document_name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {/* {this.validator.message('Required Documents', this.state.documents, 'required', { className: 'text-danger error-msg' })} */}
                                  </div>
                                  <div class="form-group col-4">
                                    <label> Admission Process</label>
                                    <textarea name='admission_process' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.admission_process} ></textarea>
                                    {/* {this.validator.message('Admission Process', this.state.admission_process, 'required', { className: 'text-danger error-msg' })} */}
                                  </div>
                                </div>
                              )
                            )}
                            {(item.cid == 4 || item.cid == 6 || item.cid == 8) && (
                              <div>
                                <div class="form-group col-4">
                                  <label> Average Fees (Monthly INR) <span class="astrick">*</span></label>
                                  <input name='average_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.average_fee} />
                                  {this.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required | numeric', { className: 'text - danger error - msg' })}
                                </div>
                                <div class="form-group col-4">
                                  <label> Fees (INR)</label>
                                  <div class="row">
                                    <div class="form-group col-md-6">
                                      <input name='class_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.class_fee} />
                                    </div>
                                    <div class="form-group col-md-6">
                                      <select
                                        value={item.class_fee_type}
                                        onChange={(e) => this.handleChange(e, index)} className='form-control selectpicker'
                                        name="class_fee_type"
                                        title='Select'>
                                        <option value='1'>Per Class</option>
                                        <option value='2'>Per Participant</option>
                                        <option value='0'>NA</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-4">
                                  <label> Recurring Fees (INR)</label>
                                  <input name='recurring_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.recurring_fee} />
                                  {this.validator.message('Recurring Fees', item.recurring_fee, 'numeric', { className: 'text-danger error-msg' })}
                                </div>
                              </div>
                            )}
                           
                            {(item.cid == 3 || item.cid == 121) && (
                              <div>
                                {(item.cid == 3
                                ) && (
                                    <div class="form-group col-4">
                                      <label> Average Fees (Monthly INR) <span class="astrick">*</span></label>
                                      <input name='average_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.average_fee} />
                                      {this.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required | numeric', { className: 'text - danger error - msg' })}
                                    </div>

                                  )}
                                {(item.cid == 121
                                ) && (
                                    <div class="form-group col-4">
                                      <label> Fees (INR)</label>
                                      <div class="row">
                                        <div class="form-group col-md-6">
                                          <input name='class_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.class_fee} />
                                        </div>
                                        <div class="form-group col-md-6">
                                          <select
                                            value={item.class_fee_type}
                                            onChange={(e) => this.handleChange(e, index)} className='form-control selectpicker'
                                            name="class_fee_type"
                                            title='Select'>
                                            <option value='1'>Per Class</option>
                                            <option value='2'>Per Participant</option>
                                            <option value='0'>NA</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                  )}
                                {(item.cid == 121) && (
                                  <div class="form-group col-4">
                                    <label> {lbl_entry} (INR)</label>
                                    <input name='average_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.average_fee} />
                                    {this.validator.message(lbl_entry, item.average_fee, 'numeric', { className: 'text-danger error-msg' })}
                                  </div>
                                )}
                              </div>
                            )}
                            {(item.cid == 7) && (
                              <div>
                                <div class="form-group col-4">
                                  <label> Price Start From (INR)</label>
                                  <input name='average_fee' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={this.state.average_fee} />
                                  {this.validator.message(lbl_entry, item.average_fee, 'numeric', { className: 'text-danger error-msg' })}
                                </div>
                              </div>
                            )}

                            <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                            <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                            Submit Admission info
                            </button>
                            </div>

                          </div>



                        )}

                        
                    </div>
                  </CardBody>
                </Collapse>
              </Card>

                  </form>

              </div>
            )
          })}
                  
          
        
        </div>
        <NotificationContainer/>
      </React.Fragment>

    );
  }
  submitForm = (e, i) => {
    e.preventDefault();
    this.setState({
      btnDisabled: true
    })
    if (this.validator.allValid()) {
     
      const { user_type, login_id, set_id } = this.state.user_data;
      let request = JSON.stringify({
        user_type: user_type,
        login_id: login_id,
        sid: set_id,
        active_status: this.state.active_status,
        data: this.state.page_data[i],
        url: 'updateAdmission'
      });
      partnerApi(request).then(res => {

         
        if (res.status === 1) {
          NotificationManager.success(res.message);

          this.setState({
            btnDisabled: false
          })

        } else {
          NotificationManager.error(res.message);
        }
         
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  async getDropData() {
    let documents = [];
    let res1 = await FetchCall.getSchoolListDatas('documents');
    if (res1.status === 1) {
      documents = res1.results;
    }
    this.setState({
      dropdown: {
        documents: documents
      }
    });
  }

}

export default Admission_other;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/admission_otherV3.jsx